// Define the filter state interface
export interface FilterState {
  dateRange: {
    from: string;
    to: string;
  };
  datePreset?: DatePreset; // Store the date preset concept (optional for backward compatibility)
  category: string;
  enterer: string;
  recipient: string;
}

// Define date preset types
export const DATE_PRESETS = {
  ALL_DATES: 'all_dates',
  TODAY: 'today',
  YESTERDAY: 'yesterday',
  THIS_WEEK: 'this_week',
  LAST_WEEK: 'last_week',
  THIS_MONTH: 'this_month',
  LAST_MONTH: 'last_month',
  THIS_YEAR: 'this_year',
  LAST_YEAR: 'last_year',
  DATE_RANGE: 'date_range'
} as const;

export type DatePreset = typeof DATE_PRESETS[keyof typeof DATE_PRESETS];

// Interface for date range
export interface DateRange {
  from: Date;
  to: Date;
  label: string;
}
